import { Container } from '@mui/material';

export default function GestProvincias({ element: component }) {
    return (
        <Container>
            {component}
        </Container>
    );
}
